// Guiding grief modal

jQuery(document).ready(function($) {
  $('[data-reveal]').on('closed.zf.reveal', function(e) {
    e.preventDefault();

    //turn off video (if modal has one) when closed
    var iframe = $(this).find('iframe');
    var iframe1 = $('.iframe1');
    var url = $(iframe).attr('src');
    if (typeof iframe !== 'undefined') {
      $(iframe1).attr('src', '');
      $(iframe1).attr('src', url);
    }
    return false;
  });
});
